import React, { useState } from "react";
import CompanyNavbar from "./CompanyNavbar";
import './card.css';
import Cookies from "js-cookie";
import axios from "axios";
import url from "../../function/url";
import Swal from "sweetalert2";
function AddProducts() {
    const ID = Cookies.get("log_id");
    function openDiv() {
        document.getElementById('taxDiv').style.display = 'flex';
        
    }
    function closeDiv() {
        document.getElementById('taxDiv').style.display = 'none';
    }
    function GoodsServices(val) {
        if (val == 'goods'){
            document.getElementById('hsnDiv').style.display = 'flex';
            document.getElementById('sacDiv').style.display = 'none';
        } else if(val == 'services'){
            document.getElementById('sacDiv').style.display = 'flex';
            document.getElementById('hsnDiv').style.display = 'none';
        }
        setType(val);
    }
    function ValidateHSN() {
        var hsn = document.getElementById('HSN').value;
        if (hsn.length < 6){
            document.getElementById('hsnerror').style.display = 'flex';
        } else{
            document.getElementById('hsnerror').style.display = 'none';
        }
    }
    function ValidateSAC() {
        var sac = document.getElementById('SAC').value;
        if (sac.length < 6){
            document.getElementById('sacerror').style.display = 'flex';
        } else {
            document.getElementById('sacerror').style.display = 'none';
        }
    }
    const [type,setType] = useState("");
    const [hsn,setHSN] = useState("");
    const [sac,setSAC] = useState("");
    const [name,setName] = useState("");
    const [description,setDescription] = useState("");
    const [price,setPrice] = useState("");
    const [stock,setStock] = useState("");
    const [contact,setContact] = useState("");
    const [image,setImage] = useState(null);
    const [Category,setCategory] = useState("");
    const [tax,setTax] = useState("");
    const [inter,setInter] = useState("");
    const [intra,setIntra] = useState("");
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        },
      });
    function CheckHSN(val) {
        var Hsn = val;
        const formdata = new FormData();
        formdata.append('hsn',Hsn);
        axios.post(`${url.path}/check_HSN/`,formdata)
        .then((res) =>{
            if(res.data.status){
                if(res.data.hs == 'exist'){
                    Toast.fire({
                        icon:'error',
                        title:'HSN Already Exists...'
                    })
                }
            }
        }).catch((err) => {
            console.log("ERROR", err);
          });
    }

    function handleHSN(val) {
        CheckHSN(val);
        setHSN(val);
    }

    function CheckSAC(val) {
        var Sac = val;
        const formdata = new FormData();
        formdata.append('sac',Sac);
        axios.post(`${url.path}/check_SAC/`,formdata)
        .then((res) =>{
            if(res.data.status){
                if(res.data.hs == 'exist'){
                    Toast.fire({
                        icon:'error',
                        title:'SAC Already Exists...'
                    })
                }
            }
        }).catch((err) => {
            console.log("ERROR", err);
          });
    }
    function handleSAC(val) {
        CheckSAC(val);
        setSAC(val);
    }
    function  phonenumbervalidation(val) {
        var phonenumber = val;
        var regPhoneNumber = /^\d{10}$/; 
        if (regPhoneNumber.test(phonenumber)){
          document.getElementById('phno').style.display = 'none'; 
        } else {
          document.getElementById('phno').style.display = 'block'; 
        }
      }
    function handleSubmit(e) {
        e.preventDefault();
        const formdata = new FormData();
        formdata.append('id',ID);
        formdata.append('name',name);
        formdata.append('description',description);
        formdata.append('price',price);
        formdata.append('type',type);
        formdata.append('hsn',hsn);
        formdata.append('sac',sac);
        formdata.append('contact',contact);
        formdata.append('stock',stock);
        formdata.append('category',Category);
        formdata.append('tax',tax);
        formdata.append('inter',inter);
        formdata.append('intra',intra);
        if (image){
            formdata.append('image',image);
        }
        axios.post(`${url.path}/add_product/`,formdata)
        .then((res) =>{
            if(res.data.status){
                Toast.fire({
                    icon:'success',
                    title:'Product Added Success...'
                })
                AddProducts();
            }
        }).catch((err) => {
            console.log("ERROR", err);
          }); 
    }

    return(
        <>
        <CompanyNavbar />
        <div className="content">
            
            <div className="form-container">
                <div id="ndiv">
                    <h1 style={{fontSize:'30px'}}>Add Products</h1>
                </div>
                <br />
                <form onSubmit={handleSubmit}>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Type</label>
                            <select  value={type} onChange={(e) =>GoodsServices(e.target.value)} >
                                <option selected>--Select--</option>
                                <option value="goods">Goods</option>
                                <option value="services">Services</option>
                            </select>
                        </div>
                        <div className="form-group" id="hsnDiv">
                            <label>HSN</label>
                            <input type="text" id="HSN" onInput={ValidateHSN} onChange={(e) =>handleHSN(e.target.value)} placeholder="Enter HSN" />
                            <h5 style={{display:'none',color:'red'}} id="hsnerror">HSN must have six digits..</h5>
                        </div>
                        <div className="form-group" style={{display:'none'}} id="sacDiv">
                            <label>SAC</label>
                            <input type="text" id="SAC" onInput={ValidateSAC} onChange={(e) =>handleSAC(e.target.value)} placeholder="Enter SAC" />
                            <h5 style={{display:'none',color:'red'}} id="sacerror">SAC must have six digits..</h5>
                        </div>
                        <div className="form-group">
                            <label>Name</label>
                            <input type="text" placeholder="Product Name" value={name} onChange={(e) =>setName(e.target.value)}  />
                        </div>
                    </div>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Description</label>
                            <input type="text" placeholder="Description" value={description} onChange={(e) =>setDescription(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Price</label>
                            <input type="text" placeholder="Price" value={price} onChange={(e) =>setPrice(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Stock Available</label>
                            <input type="text" placeholder="Stock" value={stock} onChange={(e) =>setStock(e.target.value)} />
                        </div>
                    </div>
                    <div className="form-group-row">
                        <div className="form-group">
                            <label>Contact</label>
                            <input type="text" placeholder="Contact" value={contact} onChange={(e) =>setContact(e.target.value)} onInput={(e) =>phonenumbervalidation(e.target.value)}  />
                            <h5 style={{color:'red',display:'none'}} id="phno">Phone Number is not valid!!!</h5>
                        </div>
                        <div className="form-group">
                            <label>Image</label>
                            <input type="file" id="image" onChange={(e) => setImage(e.target.files[0])}  />
                        </div>
                        <div className="form-group">
                            <label>Category</label>
                            <select value={Category} onChange={(e) =>setCategory(e.target.value)}>
                                <option selected>--Select--</option>
                                <option value="Food">Food</option>
                                <option value="Clothing">Clothing</option>
                                <option value="Daily Need">Daily Need</option>
                                <option value="House Items">House Items</option>
                            </select>
                        </div>
                    </div>
                    
                    <div className="form-group-row">
                        <div className="form-group">
                            <label className="lab1">Tax Referance</label>
                            <div id="taxdiv" className="radio-group">
                                <label>
                                    <input type="radio" name="taxable" onClick={openDiv} onChange={(e) =>setTax(e.target.value)} value="taxable" id="taxable" /> Taxable
                                </label>
                                <label>
                                    <input type="radio" name="taxable" onClick={closeDiv} onChange={(e) =>setTax(e.target.value)} value="nontaxable" id="nontaxable" /> Non-Taxable
                                </label>
                            </div>
                        </div>
                        
                    </div>
                    <div className="form-group-row" style={{display:'none'}} id="taxDiv">
                    <div className="form-group" id="interdiv" >
                            <label>Inter State Tax</label>
                            <select name="inter" value={inter} onChange={(e) =>setInter(e.target.value)}>
                                <option>--Select--</option>
                                <option value="0">IGST 0 (0%)</option>
                                <option value="3">IGST 3 (3%)</option>
                                <option value="5">IGST 5 (5%)</option>
                                <option value="12">IGST 12 (12%)</option>
                                <option value="18">IGST 18 (18%)</option>
                                <option value="28">IGST 28 (28%)</option>
                            </select>
                        </div>
                        <div className="form-group" id="intradiv" >
                        <label>Intra State Tax</label>
                        <select name="intra" value={intra} onChange={(e) =>setIntra(e.target.value)}>
                            <option>--Select--</option>
                            <option value="0">GST 0 (0%)</option>
                            <option value="3">GST 3 (3%)</option>
                            <option value="5">GST 5 (5%)</option>
                            <option value="12">GST 12 (12%)</option>
                            <option value="18">GST 18 (18%)</option>
                            <option value="28">GST 28 (28%)</option>   
                        </select>
                        </div>
                    </div>
                    <center>
                        <div className="row">
                            <button style={{ width:'150px',height:'40px',borderRadius:'10px',color:'black',backgroundColor:'gainsboro'}} type="submit">ADD</button>
                        </div>
                    </center>
                </form>
                
            </div>

        </div>
        </>
    );
}
export default AddProducts;